<template>
    <section class="section-hero section-shaped my-0" 
    style="background-image: url('https://anthromindxx.com/ant/bj.jpeg'); /* 替换为你的图片路径 */
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: 100%;"
  >
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/brand/white.png" style="width: 200px;" class="img-fluid">
                        
                        <div class="row justify-content-between align-items-center">
                            <h1 class="text-white font-weight-light">Hi，这里是一个关于健康饮食的个人网站。</h1>
                            <p class="lead text-white mt-4">目前小范围内测中，还未对外开放，
                                    更多信息可以在个人微博主页了解。微博 ID：AnthroMindXX。</p>
                        </div>

                        <div class="btn-wrapper">
							
							
					 
							
							
                            <base-button tag="a"
                                         href="#/login"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         icon="fa fa-code">
                                登 录
                            </base-button>
                            <base-button tag="a"
                                         href="#"
                                         class="mb-3 mb-sm-0"
                                         type="white"
                                         icon="ni ni-cloud-download-95">
                                了解更多
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
export default {};
</script>
<style>
</style>
